import {
	startFullStorySession,
	stopFullStorySession
} from "../utils/helpers.js";

// import { avatarBoss, avatarBrenda, avatarKenny  } from "../Images.js";

import LevelBrenda from '../scenes/LevelBrenda';
import LevelBoss from '../scenes/LevelBoss';
import LevelKenny from '../scenes/LevelKenny';

import TwoD from "../scenes/TwoD.js";
import ThreeD from "../scenes/ThreeD.js";
// import GamePlay from "../scenes/GamePlay.js";
import SiteDown from "../scenes/SiteDown.js";
import MeetBoss from "../scenes/MeetBoss.js";

export const frameRate = 2;
export const manifest = {
	init: [
		() => startFullStorySession()
	],
	exit: [
		() => stopFullStorySession()
	],
	scenes: [
		{
			type: TwoD,
			description: "Level  ",
			data: {
				round: 1,
				// avatar: avatarKenny,
				rounds: [
					{
						bubbleText: "Hello, valued customer! I am Kenny, human customer service representative for Stuff In a Box. Would you like to <strong>cancel your subscription</strong>?",
						adText: "Cancel Your Subscription to Stuff In a Box?",
						adDelay: 1,
						audio: "level1_1",
						round: 1
	 				},
					{
						bubbleText: "Very well. Let us begin the process.",
						adText: "Are You Certain That You Want to Cancel Your Subscription to Stuff In a Box?",
						adDelay: 1,
						audio: "level1_2",
						round: 1
					},
					{
						bubbleText: "As you wish. We will now continue to begin the process.",
						adText: "Are You Absolutely Positively 100% Sure Beyond a Shadow of a Doubt That You Would Like to Cancel Your Subscription to Stuff In a Box?",
						adDelay: 1,
						audio: "level1_3",
						round: 1
					}
				]
			},
			init: [],
			exit:[]
		},
		{
			type: ThreeD,
			description: "Level 1",
			data: {
				// avatar: avatarKenny,
		    	round: 1,
		    	environment: LevelKenny,
		    	duration: 30,
		    	introDelay: 4,
		    	outroDelay: 5,
		    	bpm: 120,
		    	speed: 5,
		    	seq: [1,1,0,0,1,0,0,0,1,0,0,0,1,1,1,1],

		    	music: "music1",

				intro: "level1_4",
				outro: "level1_5",
		  		introPrompt: "RAGE CLICK THE ADS IN...",
				introBubble: "While we are in the process of processing canceling your subscription please view these special offers.",
		    	outroBubble: "I am now transferring you to my supervisor. Who is a different human person separate from me."
		  },
		  init: [],
		  exit:[]
		},
		{
			type: TwoD,
			description: "Level 2",
			data: {
				round: 2,
				// avatar: avatarBrenda,
				rounds: [
					{
						bubbleText: "Greetings, valued customer! I am Brenda, head of Customer Satisfaction at Stuff In a Box and a different human person separate from Kenny. Do you want to <strong>cancel your subscription</strong>?",
						adText: "Do You Want To Not Cancel Your Subscription to Stuff In a Box?",
						adDelay: 1,
						audio: "level2_1"
					},
					{
						bubbleText: "Certainly. Allow me to assist you.",
						adText: "Do You Really Really Want to Cancel Your Subscription to Stuff In a Box?",
						adDelay: 1,
						audio: "level2_2"
					},
					{
						bubbleText: "Right away. I shall continue to aid you.",
						adText: "Ok, Like, You Are Completely Sure that You Want to Cancel Your Subscription to Stuff In a Box and Not Continue to Receive Stuff from Stuff In a Box?",
						adDelay: 1,
						audio: "level2_3"
					},
				]
			},
			init: [],
			exit:[]
		},
		{
			type: ThreeD,
			description: "Level 2",
			data: {
				round: 2,
		    environment: LevelBrenda,
				duration: 30,
				introDelay: 4,
				outroDelay: 4,
				bpm: 130,
				speed: 4,
		    seq: [1,1,0,0,0,1,0,1,0,0,1,1,0,1,0,0],
		    music: "music2",
			intro: "level2_4",
			outro: "level2_5",

				introPrompt: "RAGE CLICK THE ADS IN...",
				introBubble: "As I continue to aid and assist in canceling your subscription please view these special offers.",
				outroBubble: "Valued customer has refused all special offers. Error. System rebooting.",


		},
		init: [],
		exit:[]
		},
		{
			type: SiteDown,
			description: "Site Down Level 2",
			data: {},
			init: [],
			exit:[]
		},
		{
			type: MeetBoss,
			description: "Site Down Level 2",
			data: {},
			init: [],
			exit:[]
		},
		{
			type: TwoD,
			description: "Level 3",
			data: {
				round: 3,
				// avatar: avatarBoss,
				rounds: [
					{
						bubbleText: "We meet again, valued customer. It was I, the<br/><strong>B</strong>inary<br/><strong>O</strong>mnipresent<br/><strong>S</strong>atisfaction<br/><strong>S</strong>ystem, all along performing a flawless simulation of humanity. Do you still desire to <strong>cancel your subscription</strong>?",
						adText: "Please Cancel My Subscription to Stuff In a Box.",
						adDelay: 1,
						audio: "level3_1"
					},
					{
						bubbleText: "Of course. Let us proceed.",
						adText: "Pretty Please Cancel My Subscription to Stuff In a Box.",
						adDelay: 1,
						audio: "level3_2"
					},
					{
						bubbleText: "Wonderful. We will now take the next step.",
						adText: "Oh Please For the Love of All That Is Sacred Just Hurry Up and Cancel My Subscription to Stuff In a Box.",
						adDelay: 1,
						audio: "level3_3"
					},
				]
			},
			init: [],
			exit:[]
		},
		{
			type: ThreeD,
			description: "Level 3",
			data: {
				round: 3,
		        environment: LevelBoss,
				duration: 30,
				introDelay: 4,
				outroDelay: 5,
				bpm: 140,
				speed: 3,

		        seq: [1,1,1,0,1,1,1,0,1,1,1,0,1,0,1,0,],

				music: "music3",

				intro: "level3_4",
		        outro: "level3_5",

				introPrompt: "RAGE CLICK THE ADS IN...",
				introBubble: "While we take the next step in canceling your subscription please enjoy these special offers.",
				outroBubble: "Error! Valued customer has successfully... CANCELED THEIR SUBSCRIPTION.",

			},
			init: [],
			exit:[]
		}
	]
};



// WEBPACK FOOTER //
// ./src/components/scenemanager/manifest.js